import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    private router: Router,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const { accessToken, businessportalAccessToken } = this.cookieService.getAll();
    let token = this.router.url.startsWith('/business-portal') ? businessportalAccessToken : accessToken;
    token = token?.replace(/"/g, '');
    return next.handle(
      request.clone({
        headers: request.headers.append('Authorization', token ? 'Bearer ' + token : ''),
        withCredentials: true,
      }),
    );
  }
}
